// Multitour.js
import React from 'react';
import './multitour.css'

const Multitour = ({ tour, navigateToTourDetails }) => {
  return (
    <div className="tour-rental-section">
    <div className="tour__option bg-white p-6 rounded-lg shadow-lg flex relative">
      <div className="w-1/2">
        <img
          src={tour.image}
          alt={tour.name}
          className="w-full h-auto"
        />
      </div>
      <div className="text w-1/2">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center border-b pb-2">
          {tour.name}
        </h3>
        <div className="text-center text-gray-600 mb-4">
          <strong>Category:</strong> {tour.category}
        </div>
        <div className="text-center">
          <button
            onClick={() => navigateToTourDetails(tour.category, tour.name)}
            className="btn primary__btn bg-blue-500 text-white px-4 py-3 rounded-full hover:bg-blue-600 mb-4"
          >
            Know More
          </button>
        </div>
      </div>
      <div className="blur-border"></div>
    </div>
    </div>
  );
};

export default Multitour;
